import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import localization from '../../../localization';

const buttonsStyle = { textTransform: 'none', color: '#b9b1b1', borderColor: '#b9b1b1' };

const HandleExpandCollapseSection = ({ handleExpandAll, handleCollapseAll }) => (
  <Box
    width="100%"
    m="auto"
    p="0 3px"
    display="flex"
    alignItems="center"
    justifyContent="space-around"
  >
    <Button
      sx={buttonsStyle}
      size="small"
      variant="outlined"
      onClick={handleExpandAll}
    >
      <OpenInFullIcon sx={{ marginRight: '3px' }} fontSize="small" />
        {localization.t('sideBar.buttons.expandAll')}
    </Button>
    <Button
      sx={buttonsStyle}
      size="small"
      variant="outlined"
      onClick={handleCollapseAll}
    >
      <CloseFullscreenIcon sx={{ marginRight: '3px' }} fontSize="small" />
        {localization.t('sideBar.buttons.collapseAll')}
    </Button>
  </Box>
);

HandleExpandCollapseSection.propTypes = {
  handleExpandAll: PropTypes.func,
  handleCollapseAll: PropTypes.func,
};

export default HandleExpandCollapseSection;
